import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';
import FAQItem from '../contact-support/components/FAQItem';

const ForceUrbaniaDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { route } = location?.state || {};
  const [selectedDuration, setSelectedDuration] = useState('3 Days');
  const [selectedCar, setSelectedCar] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!route) {
      navigate('/homepage');
    }
  }, [route, navigate]);

  const durations = ['3 Days', '4 Days', '5 Days', '6 Days'];

  const urbaniaOptions = [
  {
    id: 1,
    name: 'Urbania',
    luggage: 9,
    seats: 12,
    price: 32400,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
    alt: 'Force Urbania 12 seater luxury van with premium interiors and spacious cabin'
  },
  {
    id: 2,
    name: 'Force Urbania',
    luggage: 16,
    seats: 16,
    price: 34200,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
    alt: 'Force Urbania 16 seater luxury van with maximum seating capacity and comfort'
  }];


  const urbaniaRoutes = [
  { destination: 'Chandigarh To Manali', price: '₹ 32400/-' },
  { destination: 'Chandigarh To Shimla', price: '₹ 12960/-' },
  { destination: 'Chandigarh To Dharamshala', price: '₹ 43200/-' },
  { destination: 'Chandigarh To Amritsar', price: '₹ 18720/-' },
  { destination: 'Chandigarh To Dalhousie', price: '₹ 43200/-' },
  { destination: 'Chandigarh To Mussoorie', price: '₹ 28800/-' },
  { destination: 'Chandigarh To Himachal Pradesh', price: '₹ 21600/-' },
  { destination: 'Chandigarh To Khatu Shyam', price: '₹ 43200/-' },
  { destination: 'Chandigarh To Salasar Balaji', price: '₹ 43200/-' },
  { destination: 'Chandigarh To Kasol', price: '₹ 43200/-' },
  { destination: 'Chandigarh To Delhi Airport', price: '₹ 18720/-' },
  { destination: 'Chandigarh To Delhi', price: '₹ 18000/-' }];


  const faqData = [
  {
    question: 'How many passengers can sit in Force Urbania?',
    answer: 'Force Urbania is available in two seating configurations: 12-seater and 16-seater options. Both variants offer spacious and comfortable seating with ample legroom, making them ideal for group travel and long-distance journeys.'
  },
  {
    question: 'Can I book the Force Urbania for short trips?',
    answer: 'Yes, absolutely! While Force Urbania is perfect for multi-day tours (3-6 days), we also offer flexible booking options for short trips and single-day rentals. Contact us to discuss your specific requirements and we\'ll customize a package for you.'
  },
  {
    question: 'Can I use the Force Urbania for long distance travel?',
    answer: 'Yes, Force Urbania is specifically designed for long-distance travel with superior comfort and reliability. Our vehicles are well-maintained and equipped with modern amenities to ensure a smooth journey across all terrains, from hill stations to plains.'
  },
  {
    question: 'Does the Force Urbania have an air condition facility?',
    answer: 'Yes, all our Force Urbania vehicles come equipped with powerful air conditioning systems to ensure a comfortable journey in all weather conditions. The AC is regularly serviced and maintained for optimal performance.'
  },
  {
    question: 'What amenities are included with the Force Urbania?',
    answer: 'Force Urbania includes: Premium air conditioning, luxury push-back seats, spacious luggage compartment, music system with Bluetooth connectivity, mobile charging points, reading lights, first aid kit, fire extinguisher, and experienced professional drivers.'
  },
  {
    question: 'How can I book the Force Urbania services with a driver?',
    answer: 'Booking is simple! Select your preferred Force Urbania from the options above, click "Select Car", fill in your travel details including pickup location and date, and complete the payment. All bookings automatically include an experienced driver. You can also call us at +91-79986-66660 for assistance.'
  },
  {
    question: 'Is driver facility included in Force Urbania rental service?',
    answer: 'Yes, all Force Urbania rentals include an experienced and verified professional driver. Driver charges, daily allowances, toll taxes, and parking fees are included in the package price. Our drivers are well-trained and familiar with all major routes.'
  },
  {
    question: 'What is the cancellation policy for Force Urbania rental?',
    answer: 'Free cancellation up to 48 hours before scheduled departure with full refund. Cancellations within 48-24 hours incur 25% charge. Within 24 hours: 50% charge. No-shows are charged 100%. Refunds are processed within 5-7 business days to the original payment method.'
  },
  {
    question: 'Are there mileage limits on the rentals?',
    answer: 'Our packages include specific mileage based on the selected route and duration. For custom trips, we offer flexible mileage options. Extra kilometers beyond the package limit are charged at nominal rates. All mileage details are transparently shared before booking confirmation.'
  },
  {
    question: 'How often are the Force Urbania vehicles serviced?',
    answer: 'All our Force Urbania vehicles undergo comprehensive maintenance checks every 5,000 kilometers and thorough inspection before every trip. We maintain the highest standards of vehicle hygiene, mechanical fitness, and safety to ensure passenger comfort and security.'
  },
  {
    question: 'Can I rent the Force Urbania for corporate events?',
    answer: 'Yes, Force Urbania is perfect for corporate events, team outings, conferences, and business travel. We offer special corporate packages with flexible billing options, GST invoices, and dedicated account management. Contact us for customized corporate solutions.'
  },
  {
    question: 'Are there discounts for long term rentals?',
    answer: 'Yes, we offer attractive discounts for long-term rentals and multi-day bookings. Corporate clients, tour operators, and extended family trips qualify for special rates. Contact our team at +91-79986-66660 for customized long-term rental quotes and exclusive discounts.'
  },
  {
    question: 'what is the cost of Force Urbania rent from Chandigarh to Manali?',
    answer: 'The starting price for Chandigarh to Manali Force Urbania is ₹32,400/- for a 12-seater vehicle for 3 days. The 16-seater variant starts at ₹34,200/-. Prices vary based on duration (3-6 days) and season. All prices are inclusive of taxes, driver charges, toll fees, and parking.'
  }];


  const handleSelectCar = (car) => {
    setSelectedCar(car?.id);
    navigate('/tempo-traveller-booking', {
      state: {
        route,
        vehicle: car,
        serviceType: 'Force Urbania',
        duration: selectedDuration
      }
    });
  };

  const handleRouteClick = (routeItem) => {
    const [from, to] = routeItem?.destination?.split(' To ');
    navigate('/force-urbania-details', {
      state: {
        route: {
          from: from,
          to: to
        }
      }
    });
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="pt-16 lg:pt-20">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center">
              Chandigarh to {route?.to} Force Urbania
            </h1>
          </div>
        </div>

        {/* Duration Selection Tabs */}
        <div className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-wrap gap-2 justify-center">
              {durations?.map((duration) =>
              <button
                key={duration}
                onClick={() => setSelectedDuration(duration)}
                className={`px-6 md:px-16 py-3 rounded-full font-semibold text-sm md:text-base transition-all duration-200 ${
                selectedDuration === duration ?
                'bg-yellow-400 text-gray-900 shadow-md' :
                'bg-white text-gray-700 border border-gray-300 hover:border-yellow-400'}`
                }>

                  {duration}
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Vehicle Selection Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
          <div className="space-y-6">
            {urbaniaOptions?.map((car) =>
            <div
              key={car?.id}
              className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden">

                <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 p-4 md:p-6 items-center">
                  {/* Car Image */}
                  <div className="md:col-span-2">
                    <div className="w-full h-24 md:h-28 flex items-center justify-center">
                      <Image
                      src={car?.image}
                      alt={car?.alt}
                      className="w-full h-full object-contain" />

                    </div>
                  </div>

                  {/* Car Details */}
                  <div className="md:col-span-3">
                    <p className="text-xs text-gray-500 uppercase mb-1">Car Type</p>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900">{car?.name}</h3>
                    <button className="text-sm text-green-600 font-medium mt-1 hover:underline">
                      More Details
                    </button>
                  </div>

                  {/* Luggage */}
                  <div className="md:col-span-2 flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon name="Briefcase" size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{car?.luggage} Luggage</p>
                    </div>
                  </div>

                  {/* Seats */}
                  <div className="md:col-span-2 flex items-center gap-2">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                      <Icon name="Users" size={20} className="text-blue-600" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-900">{car?.seats} Seats</p>
                    </div>
                  </div>

                  {/* Price */}
                  <div className="md:col-span-2 text-center md:text-right">
                    <p className="text-2xl md:text-3xl font-bold text-green-600">
                      ₹{car?.price?.toLocaleString('en-IN')}/-
                    </p>
                    <p className="text-xs text-gray-500">Inc. of Taxes*</p>
                  </div>

                  {/* Select Button */}
                  <div className="md:col-span-1 flex justify-center md:justify-end">
                    <button
                    onClick={() => handleSelectCar(car)}
                    className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-2 px-6 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg">

                      Select Car
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Force Urbania Routes Section */}
        <div className="bg-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
              Force Urbania From Chandigarh
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {urbaniaRoutes?.map((routeItem, index) =>
              <div
                key={index}
                onClick={() => handleRouteClick(routeItem)}
                className="bg-gray-50 hover:bg-blue-50 border border-gray-200 hover:border-blue-300 rounded-lg p-4 transition-all duration-200 cursor-pointer group">

                  <h3 className="text-sm md:text-base font-semibold text-gray-900 group-hover:text-blue-600 mb-2">
                    {routeItem?.destination}
                  </h3>
                  <p className="text-lg md:text-xl font-bold text-blue-600">{routeItem?.price}</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Visitor's Guide Section */}
        <div className="bg-gray-50 py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
              Visitor's Guide
            </h2>
            <div className="bg-white rounded-xl shadow-md p-6 md:p-8 space-y-6">
              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Welcome to Advait Tour and Travels: Your Premier Choice for Force Urbania!
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Welcome to Advait Tour and Travels, where we transform your travel dreams into reality with our exceptional Force Urbania tour. Whether you're planning a family vacation, a corporate retreat, or a leisurely getaway with friends, our fleet of luxurious and comfortable Force Urbania vehicles is at your service. Discover why we are the go-to travel partner for those seeking an unparalleled travel experience from Chandigarh to the breathtaking landscapes of {route?.to}.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Explore {route?.to} with Ease and Comfort
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Imagine cruising through the scenic roads from Chandigarh to {route?.to}, surrounded by lush greenery, majestic mountains, and serene valleys, all from the comfort of a state-of-the-art vehicle. Our Chandigarh to {route?.to} Urbania service ensures that your journey is as enjoyable as your destination. With ample space, modern amenities, and professional drivers, we provide a seamless travel experience that allows you to relax and soak in the beauty around you.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Affordable Luxury at Your Fingertips
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  At Advait Tour and Travels, we believe that luxury travel should be accessible to everyone. That's why we offer affordable urbania rental fares in Chandigarh, allowing you to experience the best without breaking the bank. Whether you're planning a quick weekend escape or an extended vacation, our competitive pricing ensures you get the best value for your money. Plus, with our transparent pricing policy, there are no hidden charges—just pure travel bliss.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Diverse Fleet to Meet Your Needs
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  No matter the size of your travel group, we have the perfect vehicle for you. Our fleet includes a range of options to accommodate various group sizes, ensuring comfort and convenience for all. Here's a glimpse of what we offer:
                </p>
                <div className="space-y-3">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Hire 9 Seater Force Urbania in Chandigarh</h4>
                    <p className="text-gray-700 leading-relaxed">
                      Ideal for small groups or family outings, providing a cozy and intimate travel experience.
                    </p>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Hire 12 Seater Force Urbania in Chandigarh</h4>
                    <p className="text-gray-700 leading-relaxed">
                      Perfect for mid-sized groups, offering plenty of room and amenities for a comfortable journey.
                    </p>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Hire 16 Seater Force Urbania in Chandigarh</h4>
                    <p className="text-gray-700 leading-relaxed">
                      Spacious and well-equipped for large groups, perfect for corporate retreats or large family gatherings.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Premium Travel Experience
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  For those who seek the pinnacle of luxury, our luxury Urbania Hire in Chandigarh on rent service is tailored just for you. These premium vehicles are equipped with plush interiors, advanced entertainment systems, and all the modern conveniences you need for a truly lavish travel experience. Whether it's a special occasion or you simply prefer the finer things in life, our luxury urbanias will exceed your expectations.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Flexible and Convenient Rental Options
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Planning an outstation trip? Hire our force urbania on rent in Chandigarh for outstation rides. Our service is designed to cater to your specific travel needs. Whether you're heading to the hills of {route?.to}, the spiritual sites of Himachal Pradesh, or any other destination, our vehicles are equipped to handle long journeys with ease. Enjoy the freedom to explore at your own pace with the convenience of a dedicated vehicle at your disposal.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Transparent and Competitive Pricing
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Understanding your budget is important to us. That's why we offer clear and straightforward pricing options. If you're looking for the Chandigarh to {route?.to} Urbania price or force urbania prices in Chandigarh, Advait Tour and Travels provide detailed quotes to help you make an informed decision. Our goal is to provide affordable rates for luxury force urbania in Chandigarh, ensuring that you enjoy a high-quality travel experience without any financial stress.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Easy Booking Process
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Booking your travel with Advait Tour and Travels is a breeze. Simply visit our website or give us a call to book force urbania from Chandigarh. Our friendly and knowledgeable staff are always ready to assist you with your queries and booking needs. We strive to make the process as smooth and hassle-free as possible, so you can focus on planning your adventure.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Why Choose Advait Tour and Travels?
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  When you choose Advait Tour and Travels, you're not just booking a vehicle—you're choosing a travel partner committed to making your journey memorable. Here are a few reasons why our customers keep coming back:
                </p>
                <div className="space-y-3">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Quality and Comfort</h4>
                    <p className="text-gray-700 leading-relaxed">
                      Our Force Urbania vehicles are meticulously maintained to ensure a safe, comfortable, and enjoyable ride.
                    </p>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Professional Drivers</h4>
                    <p className="text-gray-700 leading-relaxed">
                      Our drivers are experienced, courteous, and dedicated to providing excellent service.
                    </p>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Customer Satisfaction</h4>
                    <p className="text-gray-700 leading-relaxed">
                      We prioritize your satisfaction and go above and beyond to meet your travel needs.
                    </p>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Flexible Options</h4>
                    <p className="text-gray-700 leading-relaxed">
                      With a diverse fleet and various rental options, we cater to all types of travel requirements.
                    </p>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">Affordable Luxury</h4>
                    <p className="text-gray-700 leading-relaxed">
                      Enjoy the best of both worlds with our luxurious yet affordable travel solutions.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Corporate and Group Travel Solutions
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Planning a corporate retreat or a large group outing? Hire our Force Urbania in Chandigarh that is perfect for such occasions. These spacious vehicles can accommodate large groups comfortably, making them ideal for team-building activities, conferences, and group tours. Enjoy the journey together and arrive at your destination refreshed and ready to explore.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Customizable Your Tour
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  At Advait Tour and Travels, we understand that every traveler has unique preferences and requirements. That's why we offer customizable tours tailored to your specific needs. Whether you need a one-day rental or an extended multi-day tour, we can customize it to fit your schedule and budget. Contact us to discuss your requirements and let us craft the perfect travel experience for you.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Safety First
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Your safety is our top priority. All our Force Urbania vehicles are equipped with the latest safety features and undergo regular maintenance checks to ensure they are in top condition. Our drivers are trained in safe driving practices and are committed to providing a secure travel experience. Travel with peace of mind knowing that you're in good hands with Advait Tour and Travels.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Join the Advait Tour and Travels Family
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  When you choose Advait Tour and Travels, you become part of our family. We value our customers and strive to build lasting relationships based on trust and satisfaction. From the moment you book with us to the time you complete your journey, we are dedicated to providing you with exceptional service and support.
                </p>
              </div>

              <div>
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">
                  Book Your Force Urbania Today!
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Ready to embark on your {route?.to} adventure with Advait Tour and Travels? Don't wait! Book force urbania from Chandigarh today and experience the perfect blend of luxury, comfort, and affordability. Visit our website, call us, or drop by our office to make your reservation. We look forward to making your journey unforgettable!
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="bg-white py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">FAQs</h2>
            <div className="max-w-4xl mx-auto space-y-4">
              {faqData?.map((faq, index) =>
              <FAQItem key={index} question={faq?.question} answer={faq?.answer} />
              )}
            </div>
          </div>
        </div>

        {/* 24/7 Contact Support Section */}
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Icon name="Headphones" size={32} className="text-white" />
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                We're here for you 24/7!
              </h2>
            </div>
            <p className="text-white/90 text-lg mb-6">Give us a call anytime</p>
            <a
              href="tel:+917998666660"
              className="inline-flex items-center gap-2 bg-white text-orange-600 font-bold text-xl px-8 py-4 rounded-lg hover:bg-gray-100 transition-colors duration-200 shadow-lg">

              <Icon name="Phone" size={24} />
              +91-79986-66660
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>);

};

export default ForceUrbaniaDetails;